const steps = [
  {
    icon: 'ri-search-line',
    title: '先选题材',
    desc: '从校园、同居、暧昧、逆后宫四大分类入手，明确自己更偏爱哪种恋爱氛围。',
  },
  {
    icon: 'ri-filter-2-line',
    title: '再筛标签',
    desc: '每部作品都有对应标签，如"同桌""青梅竹马""多男主"，帮你在细分口味里精准锁定。',
  },
  {
    icon: 'ri-star-line',
    title: '看评分追更',
    desc: '参考站内人气与评分，结合连载话数判断是否入坑，避免踩雷长坑。',
  },
  {
    icon: 'ri-heart-fill',
    title: '收藏入坑',
    desc: '找到心仪作品后关注更新，不错过每一次心动转折与剧情高潮。',
  },
];

const categoryFaq = [
  { label: '校园系', value: '青涩、慢热，适合喜欢纯爱与青春氛围的读者。' },
  { label: '同居系', value: '温馨、日常，在同一个屋檐下感情自然升温。' },
  { label: '暧昧系', value: '推拉、拉扯，成年向的克制与试探，张力十足。' },
  { label: '逆后宫系', value: '多男主、多CP，享受被围绕的抉择与养成体验。' },
];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-semibold text-secondary-900">
            <i className="ri-compass-3-line" />
            入坑指南
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            四步找到你的心动漫画
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            恋爱后宫作品数量众多，掌握这套方法，就能在羞羞动漫漫画聚合页里快速找到适合自己的那一部。
          </p>
        </div>

        <div className="mb-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <article
              key={step.title}
              className="relative rounded-lg bg-background-100/70 p-5 transition-colors hover:bg-background-200/60"
            >
              <span className="font-heading absolute right-4 top-3 text-4xl font-black text-background-300">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className={step.icon} />
              </span>
              <h3 className="mb-2 text-lg font-semibold text-foreground-950">{step.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </article>
          ))}
        </div>

        <div className="rounded-lg bg-background-100/70 p-6 md:p-8">
          <h3 className="font-heading mb-5 text-xl font-bold text-foreground-950 md:text-2xl">
            四大分类怎么选？
          </h3>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {categoryFaq.map((item) => (
              <div key={item.label} className="flex gap-3">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm text-accent-800">
                  <i className="ri-check-line" />
                </span>
                <div>
                  <h4 className="text-base font-semibold text-foreground-950">{item.label}</h4>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}